window.BookingDetailsSidepanel = {
  renderStartTime: null,

  open({ showLoader = true } = {}) {
    this.renderStartTime = performance.now();

    document
      .querySelector("body")
      .setAttribute("data-booking-details-sidepanel", "open");

    document
      .querySelector("#j-booking-details-sidepanel")
      .setAttribute("data-show-loader", showLoader);
  },
  close() {
    document
      .querySelector("body")
      .removeAttribute("data-booking-details-sidepanel");

    this.clear();
  },
  clear() {
    this.renderStartTime = null;

    if (window.ReactRailsUJS) {
      ReactRailsUJS.unmountComponents("#j-booking-details-sidepanel .content");
    }
    $("#j-booking-details-sidepanel .content").html("");
  },
  render(content) {
    if (window.ReactRailsUJS) {
      ReactRailsUJS.unmountComponents("#j-booking-details-sidepanel .content");
    }
    $("#j-booking-details-sidepanel .content").html(content);

    document
      .querySelector("#j-booking-details-sidepanel")
      .setAttribute("data-show-loader", false);

    const renderEndTime = performance.now();

    window.metrics?.registerAction(
      window.metrics?.Actions.BOOKING_SIDE_PANEL_OPEN,
      {
        duration: this.renderStartTime
          ? renderEndTime - this.renderStartTime
          : 0,
        referrer: document.referrer || window.location.href,
        numberOfRooms: window.IDENTITY.traits.number_of_rooms,
      },
      false, // Concatenates test_ prefix on name for not polluting New Relic metrics/dashboards
    );
  },
  renderEditRoomAfterOccupancyChanged: (bookedRoomId) => {
    const locale = document?.querySelector("html").attributes.lang.value;
    const ACTION = `/${locale}/admin/booking-manager/edit-booked-room-occupancy`;

    $.ajax({
      type: "GET",
      url: ACTION,
      data: {
        room_occupancy_changed: true,
        booked_room: {
          id: $(
            `#edit_booked_form_${bookedRoomId} [name="booked_room[id]"]`,
          ).val(),
          total_adult: $(
            `#edit_booked_form_${bookedRoomId} [name="booked_room[total_adult]"]`,
          ).val(),
          total_children: $(
            `#edit_booked_form_${bookedRoomId} [name="booked_room[total_children]"]`,
          ).val(),
        },
      },
    });
  },
};

window.renderBookingDetailsSidepannelContent = function renderBookingDetailsSidepannelContent(content) {
  BookingDetailsSidepanel.render(content);
};

window.openBookingDetailsSidepanel = function openBookingDetailsSidepanel() {
  BookingDetailsSidepanel.open();
};
window.closeBookingDetailsSidepannel = function closeBookingDetailsSidepannel() {
  BookingDetailsSidepanel.close();
};
